import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Loader2, Sparkles, XCircle } from 'lucide-react';
import { apiRequest } from '../lib/apiClient';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const handleCallback = async () => {
      const sessionId = new URL(window.location.href).searchParams.get('session_id');

      if (!sessionId) {
        setStatus('error');
        setErrorMessage('No session_id was provided by the authentication provider.');
        return;
      }

      try {
        await apiRequest('/api/auth/session', {
          method: 'POST',
          body: JSON.stringify({ session_id: sessionId }),
        });

        setStatus('success');
        setTimeout(() => {
          navigate('/library', { replace: true });
        }, 1200);
      } catch (error) {
        setStatus('error');
        setErrorMessage(error.message || 'Authentication failed');
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FDFCF8] px-4">
      <div className="max-w-md text-center">
        <div className="mb-8">
          <Sparkles className="mx-auto mb-4 text-[#D4AF37]" size={48} />
          <h1 className="font-serif text-2xl">VowVisionsAI</h1>
        </div>

        {status === 'processing' && (
          <div className="space-y-4">
            <Loader2 className="mx-auto animate-spin text-[#D4AF37]" size={32} />
            <p className="text-[#8A8A8A]">Completing sign in...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="space-y-4">
            <CheckCircle className="mx-auto text-green-500" size={48} />
            <p className="font-medium text-[#2D2D2D]">Welcome back</p>
            <p className="text-sm text-[#8A8A8A]">Redirecting to your invitation library...</p>
          </div>
        )}

        {status === 'error' && (
          <div className="space-y-4">
            <XCircle className="mx-auto text-red-500" size={48} />
            <p className="font-medium text-[#2D2D2D]">Sign in failed</p>
            <p className="text-sm text-[#8A8A8A]">{errorMessage}</p>
            <button
              onClick={() => navigate('/', { replace: true })}
              className="mt-4 rounded-full bg-[#1F1A17] px-6 py-3 text-sm font-medium text-white"
            >
              Return home
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
